/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Enums for trackEvent
 */
export enum ApplicationInsightsEventEnum {
  /**
   * Button that opens the report link in whatsapp
   */
  OPEN_REPORT_LINK_IN_WHATSAPP = "OPEN_REPORT_LINK_IN_WHATSAPP",

  /**
   * Opens the report initialize dialog
   */
  OPEN_REPORT_INITIALIZE_DIALOG = "OPEN_REPORT_INITIALIZE_DIALOG",

  /**
   * Button that opens the report link in whatsapp
   */
  OPEN_WHATSAPP = "OPEN_WHATSAPP",

  /**
   * Button that indicates thumb up or thumb down on AI results
   */
  VOTE_AI_RESULT = "VOTE_AI_RESULT",

  /**
   * A dialog offering user to continue an attachment request referenced in local storage
   * Dialogs opens automatically on app start if an ongoing attachment request is found in local storage
   * This event is tracked when the dialog is mounted/opened
   */
  OPEN_ATTACHMENT_REQUEST_CONTINUE_DIALOG = "OPEN_ATTACHMENT_REQUEST_CONTINUE_DIALOG",

  /**
   * Help dialog at the start of the report
   */
  OPEN_REPORT_HELP_DIALOG = "OPEN_REPORT_HELP_DIALOG",

  /**
   * A feature flag was toggled via the settings UI or programmatically
   */
  TOGGLE_FEATURE_FLAG = "TOGGLE_FEATURE_FLAG",

  /**
   * User flow events inside the DocumentRuleTestDialog (open, positive, negative, apply, close)
   */
  RULE_TESTING = "RULE_TESTING"
}
